import React, {useState, useEffect} from 'react';
import {Formik} from "formik";
import RoomUpgradeForm from "../components/Booking/Upgrades/RoomUpgradeForm";
import {useParams} from "react-router-dom";
import {requestApi, showAlertAutoDis} from "../utils/utils";

const UpgradeBookingPage = () => {
    const {id} = useParams();

    const initialValues = {
        comments: '',
    };


    const handleSubmit = async (values) => {
        const params = {...values};
        params['bookingId'] = id;
        params['requestType'] = 'upgrade';

        const {data} = await requestApi('/booking/booking-request', 'POST', params);

        if (data.status === 'success')
            await showAlertAutoDis({title: 'Successful request', text: data.message});
        else
            await showAlertAutoDis({title: 'Error', text: data.message});
    };

    return (
        <div>
            <Formik enableReinitialize initialValues={initialValues} onSubmit={(values) => handleSubmit(values)}>
                {(props) => <RoomUpgradeForm {...props} />}
            </Formik>
        </div>
    )
};

export default UpgradeBookingPage;